<p-toast></p-toast>
<div class="p-3">
  <div class="page-title d-flex justify-content-between align-items-center">
    <div>
      <h3>Floor Plan Listing</h3>
    </div>
    <div>
      <p-button type="button" icon="pi pi-sync" [style.margin-right]="'0.3rem'" class="primary-btn p-button-secondary"
        (click)="resetFilters()"></p-button>
      <p-button pButton class="primary-btn" label="Create Floor Plan" (click)="openCreateSidebar()"><i
          class="pi pi-plus"></i></p-button>
    </div>
  </div>

  <div class="filters mb-3">
    <div class="filters-container w-100 m-0">
      <div class="p-1">
        <label for="search" class="dropdown-label">Search</label>
        <input type="text" placeholder="Search..."
          class="form-control" [(ngModel)]="filters.search" (input)="onFilterChange(); sanitizeInput($event)"  (keydown)="blockSpecialChars($event)"
          (paste)="blockSpecialCharsOnPaste($event)" (drop)="blockSpecialCharsOnDrop($event)">
      </div>
      <!-- <div class="p-1">
        <label for="planName" class="dropdown-label">Floor Plan Name</label>
        <p-dropdown filter="true" [options]="allPlanNames" [(ngModel)]="filters.unit" placeholder="Select Floor Plan Name"
          (onChange)="onFilterChange()" filter="true" [showClear]="true">
        </p-dropdown>
      </div> -->
      <div class="p-1">
        <label for="planName" class="dropdown-label">Select Beds</label>
        <p-dropdown [options]="allBedOptions" [(ngModel)]="filters.beds" placeholder="Select Beds"
          (onChange)="onFilterChange()" [showClear]="true">
        </p-dropdown>
      </div>
      <div class="p-1">
        <label for="planName" class="dropdown-label">Select Baths</label>
        <p-dropdown [options]="allBathOptions" [(ngModel)]="filters.baths" placeholder="Select Baths"
          (onChange)="onFilterChange()" [showClear]="true">
        </p-dropdown>
      </div>
      <div class="p-1">
        <label class="dropdown-label">Square Feet</label>
        <p-dropdown
          [options]="allSqftOptions"
          optionLabel="label"
          [(ngModel)]="filters.sq_ft"
          placeholder="Select Square Feet"
          (onChange)="onFilterChange()"
          [showClear]="true">
        </p-dropdown>
      </div>
      <!-- <div class="p-1">
        <label for="planName" class="dropdown-label">Min Square Feet</label>
        <p-dropdown [options]="minSqFtOptions" [(ngModel)]="filters.sq_ft" placeholder="Min Square Feet"
          (onChange)="onFilterChange()" [showClear]="true">
        </p-dropdown>
      </div>
      <div class="p-1">
        <label class="dropdown-label">Max Square Feet</label>
        <p-dropdown
          [options]="maxSqFtOptions"
          [(ngModel)]="filters.max_sq_ft"
          placeholder="Max Square Feet"
          (onChange)="onFilterChange()"
          [showClear]="true">
        </p-dropdown>
      </div> -->
      <!-- <div class="p-1">
        <label for="planName" class="dropdown-label">Floorplan Availability</label>
        <p-dropdown [options]="waitlistOptions" [(ngModel)]="filters.waitlist" placeholder="All Floorplans"
          (onChange)="onFilterChange()" [showClear]="true">
        </p-dropdown>
      </div> -->
    </div>

    <div class="floor-plan-listing p-4 m-1 mt-3">
      <p-table [value]="floorPlans" [lazy]="true" [paginator]="true" [rows]="10" [totalRecords]="totalRecords"
        [responsiveLayout]="'scroll'" [sortField]="sorting.field" [sortOrder]="sorting.order"
        (onLazyLoad)="getAllFloorPlans($event)"
        [rowsPerPageOptions]="[10,20,50]" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        responsiveLayout="scroll">

        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="unit">Floor Plan Name <p-sortIcon field="unit"></p-sortIcon></th>
            <th pSortableColumn="beds">Beds <p-sortIcon field="beds"></p-sortIcon></th>
            <th pSortableColumn="baths">Baths <p-sortIcon field="baths"></p-sortIcon></th>
            <th pSortableColumn="min_price">Min Price <p-sortIcon field="min_price"></p-sortIcon></th>
            <th pSortableColumn="max_price">Max Price <p-sortIcon field="max_price"></p-sortIcon></th>
            <th pSortableColumn="sq_ft">Min Square Feet <p-sortIcon field="sq_ft"></p-sortIcon></th>
            <th pSortableColumn="max_sq_ft">Max Square Feet <p-sortIcon field="max_sq_ft"></p-sortIcon></th>
            <th>Actions</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-floorPlan>
          <tr>
            <td>
              {{ floorPlan.unit }}
              <!-- <span *ngIf="floorPlan.waitlist" class="badge bg-warning text-dark"
              (click)="onWaitlistClick(floorPlan)" style="cursor:pointer">
                Waitlist
              </span> -->
            </td>
            <td>{{ floorPlan.beds }}</td>
            <td>{{ floorPlan.baths }}</td>
            <td>{{ floorPlan.min_price | currency }}</td>
            <td>{{ floorPlan.max_price | currency }}</td>
            <td>{{ floorPlan.sq_ft }}</td>
            <td>{{ floorPlan.max_sq_ft }}</td>
            <td>
              <div class="d-flex align-items-center gap-2">
              <p-button pButton class="icon-secondary-btn p-mr-2" icon="pi pi-pencil"
                (click)="editFloorPlan(floorPlan)">
              </p-button>
              <p-button pButton class="icon-primary-btn" icon="pi pi-trash" (click)="confirmDelete(floorPlan)">
              </p-button>
            </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div *ngIf="!floorPlans || floorPlans.length === 0" class="alert alert-info" role="alert">
      No floor plans available.
    </div>

    <div class="dlt-confirmation-dialog">
      <p-dialog header="Confirm Delete" [(visible)]="display" [modal]="true" [closable]="false">
        <small><i class="pi pi-exclamation-triangle text-danger"></i> Are you sure you want to delete this floor plan?</small>
        <p-footer>
          <p-button type="button" class="secondary-btn" [style.margin-right]="'0.3rem'"  pbutton label="No" icon="pi pi-times" (click)="onCancel()"></p-button>
          <p-button type="button" class="primary-btn" pbutton label="Yes" icon="pi pi-check" (click)="onConfirm()"></p-button>
        </p-footer>
      </p-dialog>
    </div>

    <p-dialog  [header]="type === 'edit' ? 'Update Floor Plan' : 'Create Floor Plan'"  [(visible)]="isSidebarVisible" [modal]="true" [position]="'right'"
      [style]="{ width: '35%' }" draggable="false">
      <app-floor-plan-form [floorPlan]="selectedFloorPlan" (save)="onFormSubmit($event)">
      </app-floor-plan-form>
    </p-dialog>

    <!-- Sidebar dialog for waitlist users -->
    <!-- <p-dialog
      header="Waitlist Users"
      [(visible)]="isWaitListSidebarVisible"
      [modal]="true"
      [position]="'right'"
      [style]="{ width: '35%' }"
      draggable="false"
      (onHide)="closeSidebar()"
    >
      <ng-container *ngIf="waitlistUsers.length > 0; else noUsers">
        <ul>
          <li *ngFor="let user of waitlistUsers">
            {{ user.name }} - {{ user.email }}
            <span *ngIf="user.phone">({{ user.phone }})</span>
            <span *ngIf="user.source"> [{{ user.source }}]</span>
          </li>
        </ul>
      </ng-container>

      <ng-template #noUsers>
        <p>No users on waitlist for this unit.</p>
      </ng-template>
    </p-dialog> -->
  </div>